import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import RcSlider from 'rc-slider';
import { generateMarks } from './helpers.js';
import { SliderContainer, ValueLabel } from './styled.js';
export const Slider = forwardRef(function Slider({ disabled = false, min = 0, max = 100, step = 1, value, formatValueLabel, withMarks = false, onChange, isApplyOnAfterChange }, ref) {
    const [stateValue, setStateValue] = React.useState(value);
    // a value set from outside - a form reset, a value applied by code - moves the handle as well
    React.useEffect(() => {
        setStateValue(value);
    }, [value]);
    const valueLabel = React.useMemo(() => {
        const v = isApplyOnAfterChange ? stateValue : value;
        return formatValueLabel ? formatValueLabel(v) : v;
    }, [formatValueLabel, isApplyOnAfterChange, stateValue, value]);
    return (_jsxs(_Fragment, { children: [_jsx(ValueLabel, { "data-testid": 'slider-value', children: valueLabel }), _jsx(SliderContainer, { $disabled: disabled, "data-value": value, "data-at-min": value === min, "data-at-max": value === max, children: _jsx(RcSlider, { ref: ref, disabled: disabled, min: min, max: max, step: step, value: isApplyOnAfterChange ? stateValue : value, onChange: isApplyOnAfterChange ? (v) => setStateValue(v) : onChange, onAfterChange: isApplyOnAfterChange ? onChange : undefined, marks: withMarks ? generateMarks(min, max, step) : undefined }) })] }));
});
Slider.displayName = 'Slider';
